<script lang="ts">
	import { Button } from 'flowbite-svelte';
  import { marked } from 'marked';
  import { v4 as uuidv4 } from 'uuid'; // Install with npm install uuid
	import AutoExpandingInput from '../ui/AutoExpandingInput/AutoExpandingInput.svelte';
	import logoImg from './images/logo.svg';
	import { PaperAirplane } from 'svelte-heros-v2';
	import { onMount } from 'svelte';
	import { EntityApi } from '$lib/services/entity';

	let value: any;
	let input: any;
	let messageList: any[] = [];
	let messageWindow: HTMLElement;
	let loading = false;

  const ConnId = uuidv4()

	// const getUrl = (essence) => {
	// 	let link = '';
  //
	// 	if (essence.resource === 'events') {
	// 		link += `/profile/events`;
	// 	} else if (essence.resource === 'nationality-pages' || essence.resource === 'nationalities') {
	// 		link += '/nationalities/' + essence?.title;
	// 		return link;
	// 	} else {
	// 		link += `/${essence.resource}`;
	// 	}
  //
	// 	if (essence.id) {
	// 		link += `/${essence.id}`;
	// 	}
  //
	// 	return link;
	// };

	// Отправляем сообщение введенное пользователем
	const sendMessage = async () => {
		if (!value) return;

		loading = true;

		const Question = value;
		value = '';

		const { data , err } = await EntityApi().getResultsByQuestion({
      data: { Question, ConnId }
		});

		if (err) {
			console.log(err);
			loading = false;
			return;
		}

		if (data?.Answer) {
			messageList = [
				...messageList,
				{
					id: messageList.length + 1,
					text: marked(Question),
					my: true
				},
				{
					id: messageList.length + 4,
					text: marked(data.Answer),
					my: false
				}
			];
		} else {
			messageList = [
				...messageList,
				{
					id: messageList.length + 1,
					text: Question,
					my: true
				},
				{
					id: messageList.length + 2,
					text: 'Кажется, ничего не найдено. Поисковый ИИ находится в режиме обучения.',
					my: false
				}
			];
		}

		loading = false;

		/* Скролим вниз */
		setTimeout(() => {
			messageWindow?.scrollTo(0, messageWindow.scrollHeight);
			input.focus();
		});
	};

	/**
	 * Вызываем функцию отправки сообщения при клике на Enter
	 */
	async function postChatMessage(e: CustomEvent) {
		if (e.detail.key !== 'Enter') return;
		if (e.detail.key === 'Enter' && e.detail.shiftKey === true) return;
		if (!(e.detail.target instanceof HTMLTextAreaElement)) return;

		await sendMessage();
	}

	onMount(() => {
		input.focus();
	});
</script>

<div class="w-[400px] rounded-[20px] shadow-lg overflow-hidden">
	<div
		class="h-[113px] relative z-0 bg-[linear-gradient(180deg,_#21305a_22.12%,_#1d4293_110.62%)] text-white pt-6 pl-7"
	>
		<div class="flex items-center">
			<img src={logoImg} class="shrink-0 mr-8 object-cover" width="69" alt="" />
			<div>
				<div class="text-base font-semibold -mb-0.5">Национальная политика</div>
				<div class="text-sm font-normal">Виртуальный ассистент</div>
			</div>
		</div>

		<div
			class="w-[20px] h-[40px] absolute top-[53px] left-0 bg-transparent rounded-bl-[20px] shadow-[0_20px_0_0_#ffffff]"
		/>

		<div class="w-2.5 h-2.5 bg-lime-200 rounded-full absolute top-8 right-8" />
	</div>
	<div class="bg-white rounded-tr-[20px] -mt-[20px] overflow-hidden relative pt-5 px-1">
		<!-- Messages -->
		<div class="h-[348px] overflow-auto custom-scrollbar" bind:this={messageWindow}>
			<div class="px-6 py-5 min-h-full flex flex-col justify-end">
				{#each messageList as msg, i (msg.id)}
					<div class="flex {msg.my ? 'justify-end' : ''} {i === 0 ? 'mt-0' : 'mt-5'}">
						<div class:text-right={!!msg.my} class="flex-1 max-w-full">
							<div
								class:bg-gray-100={!!msg.my}
								class:bg-blue-100={!msg.my}
								class="inline-block rounded-lg px-4 py-2.5 text-gray-700 text-left break-words max-w-full text-sm"
							>
								<span>{@html msg.text}</span>
							</div>
						</div>
					</div>
				{/each}
			</div>
		</div>

		<!-- Input -->
		<div class="p-7 shrink-0 border-t border-gray-200">
			<AutoExpandingInput
				on:keypress={postChatMessage}
				placeholder="Напишите сообщение..."
				bind:value
				bind:input
				disabled={loading}
			>
				<Button
					slot="right"
					size="sm"
					class="!p-1 text-blue-400 bg-transparent hover:bg-transparent focus:ring-0"
					type="submit"
					on:click={sendMessage}
					disabled={loading}
				>
					<PaperAirplane size="20" variation="solid" class="outline-none" />
				</Button>
			</AutoExpandingInput>
		</div>
	</div>
</div>
